import { useStartupSplashProgress } from "@atoms/atom-client";
import LoadingSplash from "@atoms/atom-components/src/components/LoadingSplash";

export function ProjectSplashScreen() {
  const progress = useStartupSplashProgress();

  return <LoadingSplash appName="PP51" progress={progress} />;
}
